function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from "vue-property-decorator";
import { State } from "vuex-class";
import { updateProfile } from "@/api/user/user";
var Profile = /*#__PURE__*/ function(Vue1) {
    "use strict";
    _inherits(Profile, Vue1);
    var _super = _createSuper(Profile);
    function Profile() {
        _classCallCheck(this, Profile);
        var _this;
        _this = _super.apply(this, arguments);
        _this.dialogVisible = false;
        _this.phone = "";
        return _this;
    }
    var _proto = Profile.prototype;
    _proto.mounted = function mounted() {
        this.phone = this.userInfo.phone;
    };
    _proto.onSubmit = function onSubmit() {
        var _this = this;
        updateProfile({
            phone: this.phone
        }).then(function() {
            _this.$message({
                message: "\u4FEE\u6539\u6210\u529F\uFF01",
                type: "success"
            });
            _this.userInfo.phone = _this.phone;
            _this.dialogVisible = false;
        }).catch(function() {});
    };
    _createClass(Profile, [
        {
            key: "tableColumnConfig",
            get: function get() {
                return [
                    {
                        label: "ID",
                        value: this.userInfo.id
                    },
                    {
                        label: "\u90AE\u7BB1",
                        value: this.userInfo.email
                    },
                    {
                        label: "\u59D3\u540D",
                        value: this.userInfo.real_name
                    },
                    {
                        label: "\u624B\u673A\u53F7\u7801",
                        value: this.userInfo.phone
                    },
                    {
                        label: "\u4E00\u7EA7\u89D2\u8272",
                        value: this.userInfo.role_name
                    },
                    {
                        label: "\u4E8C\u7EA7\u89D2\u8272",
                        value: this.userInfo.sub_role_name
                    },
                    {
                        label: "\u4E09\u7EA7\u89D2\u8272",
                        value: this.userInfo.third_role_name
                    }
                ];
            }
        }
    ]);
    return Profile;
}(Vue);
__decorate([
    State(function(state) {
        return state.user.info;
    })
], Profile.prototype, "userInfo", void 0);
Profile = __decorate([
    Component
], Profile);
export { Profile as default };
